module.exports = __webpack_public_path__ + "static/img/digital-composite-interpretive-sign05.09e4889.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/composite/digital-composite-interpretive-sign05.jpg
// module id = 821
// module chunks = 0